export class TranslatorConverter{
    genderConverter(isMale:boolean):string{
        return isMale ? 'مرد' : 'زن';
    }
    public translateInternalTransferType(v:number){
        switch(v){
            case 10: return "انبار به انبار";
            case 11: return "کد به کد";
            default:return "نامشخص";
        }
    }
    
    public requestBillTypeNameConverter(billType:number): string{
        switch (billType) {
            case 1: return "رسید";
            case 2: return "حواله";
            case 3: return "رسید رزرو";
            case 4: return "حواله رزرو";
            default: return "";
        }
    }
    
    payableReceivableConverter(v: number) {
        switch(v){
            case 1:return 'پرداخت';
            case 2:return 'دریافت';
            default:return '';
        }    
    }
    methodConverter(v: number) {
        switch(v){
            case 1:return 'فروش';
            case 2:return 'مرجوعی';
            case 3:return 'خرید';
            case 4:return 'مرجوعی خرید';
            case 5:return 'پوز';
            case 6:return 'کارت به کارت';
            case 7:return 'کنسلی فروش';
            case 8:return 'شبا';
            case 9:return 'نقد';
            case 10:return 'انتقال وجه';
            case 12:return 'چک';
            case 13:return 'تسهیلات';
            default:return '';
        }    
    }
    arapTransactionStatusConverter(v: number) {
        switch(v){
            case 1:return 'در انتظار تایید';
            case 2:return 'تایید شده';
            case 3:return 'رد شده';
            default:return '';
        }    
    }
    public paymentProcessStateNameConverter(v:number):string{
        switch(v){
            case 1:return 'در انتظار دستور';
            case 2:return 'در انتظار مجوز';
            case 3:return 'دارای مجوز';
            case 4:return 'پرداخت شده';
            default:return '';
        }
    }
    public paymentProcessTypeNameConverter(v:number):string{
        switch(v){
            case 1:return 'پیش پرداخت';
            case 2:return 'علی الحساب';
            case 3:return 'تسویه حساب';
            default:return '';
        }
    }
    public transactionTransferTypeNameConverter(v:number):string{
        switch(v){
            case 1:return 'نقد';
            case 2:return 'پوز';
            case 3:return 'کارت به کارت';
            case 4:return 'انتقال وجه';
            case 5:return 'چک';
            case 6:return 'برداشت';
            case 7:return 'آنلاین';
            case 8:return 'شبا';
            default:return '';
        }
    }
    public translateAccountType(v:number){
        switch(v){
            case 1: return "حساب جاری";
            case 2: return "پس انداز";
            case 3: return "قرض الحسنه";
            default:return "نامشخص";
        }
    }
    
}